import { toast } from "react-toastify";
import Api from "../../../axios";
import { callLoader } from "../../../common/actions/app";

let ACTION_USER_LIST = {
    type: 'USER_LIST',
    payload: {
        rows: [],
        total: 0,
        pagination: [],
    },
};

let ACTION_USER_VIEW = {
    type: 'USER_VIEW',
    payload: {
        profile: '',
        name: '',
        username: '',
    },
};

let callUserListGet = (filter = {}, pg = 1) => (dispatch) => {
    dispatch(callLoader(true))
    Api.get('/users?pg=' + pg).then((data) => {
        dispatch(callLoader(false))
        if (!data)
            return

        ACTION_USER_LIST.payload.rows = data.rows
        ACTION_USER_LIST.payload.total = data.total
        ACTION_USER_LIST.payload.pagination = data.pagination
        dispatch(ACTION_USER_LIST)
    })
}

let callUserViewGet = (id) => (dispatch) => {
    dispatch(callLoader(true))
    Api.get('/users/' + id).then((data) => {
        dispatch(callLoader(false))
        if (!data)
            return

        ACTION_USER_VIEW.payload.profile = data.profile
        ACTION_USER_VIEW.payload.name = data.name
        ACTION_USER_VIEW.payload.username = data.username
        dispatch(ACTION_USER_VIEW)
    })
}

let callUserPost = (data, success = () => { }) => (dispatch) => {
    dispatch(callLoader(true))
    Api.post('/users', data).then((data) => {
        dispatch(callLoader(false))
        if (!data)
            return

        toast.success(data.msg)
        success()
    })
}

let callUserPut = (id, data, success = () => { }) => (dispatch) => {
    dispatch(callLoader(true))
    Api.put('/users/' + id, data).then((data) => {
        dispatch(callLoader(false))
        if (!data)
            return

        toast.success(data.msg)
        success()
    })
}

let callUserClearView = () => (dispatch) => {
    ACTION_USER_VIEW.payload.profile = ''
    ACTION_USER_VIEW.payload.name = ''
    ACTION_USER_VIEW.payload.username = ''
    dispatch(ACTION_USER_VIEW)
}

let callUserDelete = (id, success = () => { }) => (dispatch) => {
    dispatch(callLoader(true))
    Api.delete('/users/' + id).then((data) => {
        dispatch(callLoader(false))
        if (!data)
            return

        toast.success(data.msg)
        success()
    })
}

export { callUserListGet, callUserViewGet, callUserPost, callUserPut, callUserDelete, callUserClearView, ACTION_USER_LIST, ACTION_USER_VIEW }